import React, { useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Tabs from 'components/v2/navs/Tabs';
import { Tab } from '@headlessui/react';
import { useParams } from 'react-router-dom';
import { fscPeriodType, getFscSettings } from 'utils/FscSettingsApiUtils';
import { showToast } from 'stores/ToastStore';
import { getCustomerV2 } from 'utils/CustomersAPIUtils';
import SessionStore from 'stores/SessionStore';
import RatesSettingsLayout from '../RatesSettingsLayout';
import Active from './Active';
import Expired from './Expired';
import Activity from './Activity';
const CARRIER = 'Carrier';
const SHIPPER = 'Shipper';
export default function FscSettings() {
    const { t } = useTranslation();
    const { id: accountId } = useParams();
    const [account, setAccount] = useState();
    const [hasExpiredSettings, setHasExpiredSettings] = useState(false);
    const tabs = useMemo(() => [
        { name: t('ACTIVE'), id: 'active-tab' },
        { name: t('EXPIRED'), disabled: !hasExpiredSettings, id: 'expired-tab' },
        { name: t('ACTIVITY'), id: 'activity-tab' },
    ], [hasExpiredSettings]);
    useEffect(() => {
        fetchAccount();
        checkExpiredStatus();
    }, []);
    async function fetchAccount() {
        const account = await getCustomerV2(accountId);
        setAccount(account);
    }
    async function checkExpiredStatus() {
        try {
            const { count } = await getFscSettings(accountId, fscPeriodType.EXPIRED, {
                perPage: 1,
            });
            setHasExpiredSettings(count > 0);
        }
        catch (e) {
            console.error(e);
            showToast(t('ERROR'), t('ERROR_WHILE_RETRIEVING_SETTINGS'), 'error');
        }
    }
    const userHasPermissionsToEdit = useMemo(() => {
        if ((account === null || account === void 0 ? void 0 : account._type) === CARRIER &&
            SessionStore.hasCarrierLanePricingManagerRole()) {
            return true;
        }
        return !!((account === null || account === void 0 ? void 0 : account._type) === SHIPPER &&
            SessionStore.hasShipperLanePricingManagerRole());
    }, [account]);
    return (React.createElement(RatesSettingsLayout, { account: account },
        React.createElement(Tabs, { tabs: tabs },
            React.createElement(Tab.Panel, null,
                React.createElement(Active, { accountId: accountId, onChange: checkExpiredStatus, actionsEnabled: userHasPermissionsToEdit })),
            React.createElement(Tab.Panel, null,
                React.createElement(Expired, { accountId: accountId })),
            React.createElement(Tab.Panel, null,
                React.createElement(Activity, { accountId: accountId })))));
}
